import React, { Component } from 'react';
import './App.css';
import Home from './Components/Home';
import About from './Components/About';
import ReactDisqusComments from 'react-disqus-comments';
import ReactGA from 'react-ga';
import ScrollableAnchor from 'react-scrollable-anchor'

class App extends Component {

  initReactGA = () => {
    ReactGA.initialize('UA-9071088-2');
    ReactGA.pageview('/home');
  }

  aboutClicked = () => {
    ReactGA.pageview('/about');
  }

  shouldComponentUpdate(nextProps, nextState){
    return false;
  }

  render() {
    this.initReactGA();
    return (
      <div className="App">
        <header className="App-header">
          <nav className="navbar">
            <div className="container">
              <h1>Surf Alert</h1>
              <ul>
                <li><a href="#about" onClick={ this.aboutClicked }>Over</a></li>
                {/* <li><a href="#comments">Discussie</a></li> */}
              </ul>
            </div>
          </nav>
        </header>
        <Home />
        <ScrollableAnchor id="about">
          <About />
        </ScrollableAnchor>
        <section id="comments">
          <ReactDisqusComments
            shortname="surfalert"
            identifier="surfalert-disqus-thread"
            title="Surf Alert"
            url="http://www.surfalert.nl" />
        </section>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js